import React, { useEffect, useCallback, useState} from 'react';
import TrackTidal from './TrackTidal.js';
import {mod} from 'utils/mod.js';
import {isNumber} from 'utils/IsNumber.js';
import {connect} from 'react-redux';
import {rewind, forward, pause, play, restart} from 'effects/midi/jaki/ScaleRules.js';

const TrackScreen = ({track, effect}) => { 
    let [selected, setSelected] = useState(undefined);
    let [rules, setRules] = useState(effect.scaleRules[track-1]);

    useEffect(() => {
        setRules(effect.scaleRules[track-1]);
    }, [effect, track, setRules]);

    const onClickAdd = useCallback((rule) => {
        if (selected) {
            let index = rules.indexOf(selected);
            rules[index] = rule;
        } else {
            rules.push(rule);
        }

        effect.scaleRules[track-1] = [... rules];
        setRules(effect.scaleRules[track-1]);
    }, [selected, rules, effect, track, setRules]);

    const deleteRule = useCallback((rule) => {
        let index = effect.scaleRules[track-1].indexOf(rule);
        effect.scaleRules[track-1].splice(index,1);
        setRules([... effect.scaleRules[track-1]]);
    }, [effect, track, setRules]);

    const setRuleValue = useCallback((rule, value) => {
        if (rule.value !== undefined) {
            rule.value = value;
            setRules([... effect.scaleRules[track-1]]);
        }
    }, [effect, track, setRules]);

    const moveRule = useCallback((rule, off) => {
        let index = rules.indexOf(rule);
        let goalIndex = mod(index+off, rules.length);
        let tmp = rules[goalIndex];
        rules[goalIndex] = rule;
        rules[index] = tmp;
        effect.scaleRules[track-1] = [... rules];
        setRules([... rules]);
    }, [effect, rules, track, setRules]);


    useEffect(() => {
        window.addEventListener("keydown", onKeyDown);
        return () => window.removeEventListener("keydown", onKeyDown);
    }, [effect, track, setRules, selected]);

    const onKeyDown = useCallback((e) => {
        if (!selected) {
            return;
        }
        if (e.key === "Backspace") {
            deleteRule(selected);
        } else if (e.key === "ArrowLeft") {
            moveRule(selected, -1);
        } else if (e.key === "ArrowUp") {
            moveRule(selected, 1);
        } else if (isNumber(e.key)) {
            let number = parseInt(e.key);
            setRuleValue(selected, number);
        }
    }, [effect, rules, track, setRules, selected]);

    return (
        <div
          onClick={() => setSelected(undefined)}
          className="track-screen">
          Scale for Track: {track}

          <div
            onClick={(e) => e.stopPropagation()}
            className="scale-rules">
            {rules.map(rule => <RulePart isSelected={selected === rule} rule={rule} onClick={setSelected}/>)}
          </div>
          <div
            onClick={(e) => e.stopPropagation()}
            className="puzzle-options">
            <PuzzleOption onClick={onClickAdd} option={play} name="Play"/>
            <PuzzleOption onClick={onClickAdd} option={pause} name="Pause"/>
            <PuzzleOption onClick={onClickAdd} option={forward} name="Forward"/>
            <PuzzleOption onClick={onClickAdd} option={rewind} name="Rewind"/>
            <PuzzleOption onClick={onClickAdd} option={restart} name="Restart"/>
          </div>
          <TrackTidal track={track} effect={effect}/>
        </div>
    );
};

const RulePart = ({isSelected, rule, onClick}) => {
    return (
        <div
          onClick={() => onClick(rule)}
          className={isSelected ? "rule-part selected" : "rule-part"}>
          {rule.name} {rule.value !== undefined ? rule.value : ''}
        </div>
    );
};

const PuzzleOption = ({option, onClick, name}) => {
    return (
        <div
          onClick={() => onClick(option())}
          className="puzzle-option">
          {name}
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackScreen);
